import { render, staticRenderFns } from "./couponTransfer.vue?vue&type=template&id=5e14a2ac&"
import script from "./couponTransfer.vue?vue&type=script&lang=ts&"
export * from "./couponTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "couponTransfer.vue"
export default component.exports